import { Injectable } from '@angular/core';
import {CacheService} from '../cacheService/cache.service';
import {environment as ENV} from '../../../environments/environment';
import swal from 'sweetalert2';
import {EventsService} from "../eventServices/event.service";
import {UserService} from "../apiCalls/userService/user.service";
@Injectable({
  providedIn: 'root'
})
export class UtilService {
  dataTableInstance: any;
  Roles: any[] = [];
  // public CASHIER_ROUTE: any[] = [];
  constructor(private cacheService: CacheService, private eventService: EventsService, private userService: UserService) {
    this.eventService.on('NEW_LOGIN', () => {
      this.Roles = [];
    });
  }

  public getAuthUser() {
    return JSON.parse(sessionStorage.getItem(ENV.USERTOKEN));
  }
  public setRoles() {
    this.Roles = [];
    const user = this.getAuthUser();
    if(user && user.roles) {
      user.roles.forEach((role) => {
        this.Roles.push(role.name);
      });
      return this.Roles;
    } else {
      return this.Roles;
    }
  }
  public checkPrivilegeNow(users: Array<string>) {
    const Roles = [];
    const user = this.getAuthUser();
    if(user && user.roles) {
      user.roles.forEach((role: any) => {
        Roles.push(role.name as string );
      });
    }
    for (const userL of users) {
      if (Roles.includes(userL)) {
        return true;
      }
    }
    return false;
  }

  public processCommonJs2() {


   /*   // sidebar navigation
      $('.main-menu').metisMenu();

      // cwidget scroll
      $('.cwidget-scroll').slimScroll({
        height: '263px',
        wheelStep: 10,
        touchScrollStep: 50,
        color: '#efefef',
        size: '2px',
        borderRadius: '3px',
        alwaysVisible: false,
        position: 'right',
      });
*/
    // toggle fullwidth layout
   /* $('.btn-toggle-fullwidth').on('click', function() {
      if (!$('body').hasClass('layout-fullwidth')) {
        $('body').addClass('layout-fullwidth');
        $(this).find('.fa').toggleClass('fa-arrow-left fa-arrow-right');

      } else {
        $('body').removeClass('layout-fullwidth');
        $(this).find('.fa').toggleClass('fa-arrow-left fa-arrow-right');
      }
    });

    // off-canvas menu toggle
    $('.btn-toggle-offcanvas').on('click', function() {
      $('body').toggleClass('offcanvas-active');
    });

    $('#main-content').on('click', function() {
      $('body').removeClass('offcanvas-active');
    });

    // adding effect dropdown menu
    $('.dropdown').on('show.bs.dropdown', function() {
      $(this).find('.dropdown-menu').first().stop(true, true).animate({
        top: '100%'
      }, 200);
    });

    $('.dropdown').on('hide.bs.dropdown', function() {
      $(this).find('.dropdown-menu').first().stop(true, true).animate({
        top: '80%'
      }, 200);
    });

    // navbar search form
    $('.navbar-form.search-form input[type="text"]')
      .on('focus', function() {
        $(this).animate({
          width: '+=50px'
        }, 300);
      })
      .on('focusout', function() {
        $(this).animate({
          width: '-=50px'
        }, 300);
      });

    $(window).on('load', function() {
      // for shorter main content
      if ($('#main-content').height() < $('#left-sidebar').height()) {
        $('#main-content').css('min-height', $('#left-sidebar').innerHeight() - $('footer').innerHeight());
      }
    });

    $(window).on('load resize', function() {
      if ($(window).innerWidth() < 420) {
        $('.navbar-brand logo.svg').attr('src', '../assets/images/logo-icon.svg');
      } else {
        $('.navbar-brand logo-icon.svg').attr('src', '../assets/images/logo.svg');
      }
    });
*/
  }
  public openModal(id) {
    setTimeout(() => {
      (<any>$('#' + id)).modal({show: true, backdrop: 'static', keyboard: false});
    }, 20);
  }
  public closeModal(id) {
    (<any>$('#' + id)).modal('hide');
  }

  startDatatable(id) {
    setTimeout(() => {
      this.initDataTable(id);
    }, 1000);
  }

  riderTable(id, res) {
    setTimeout(() => {
      this.initDataTable(id, res);
    }, 1000);
  }

  public initDataTable(id, responsive = true) {
    if (this.dataTableInstance) {
      this.dataTableInstance.destroy();
    }
    const buttons = ['pdf', 'print', 'excel', 'csv', 'copy'];
    setTimeout(() => {
      this.dataTableInstance = ($('#' + id)as any).DataTable({
        pagingType: 'full_numbers',
        dom: 'Blfrtip',
        keys: !0,
        buttons: buttons,
        // order: [[1, 'asc']],
        language: {
          search: '_INPUT_',
          searchPlaceholder: 'Search...',
          paginate: {
            previous: '<i class=\'fas fa-angle-left\'>',
            next: '<i class=\'fas fa-angle-right\'>'
          }
        },
        select: {
          // style: 'multi'
        },
        columnDefs: [ {
          targets: 'no-sort',
          orderable: false,
        } ],
        'lengthMenu': [
          [10, 25, 50, 100],
          [10, 25, 50, 100]
        ],
        responsive: responsive,
        // serverSide: true,
        // processing: true,
      });
      $('.dt-buttons .btn').removeClass('btn-secondary').addClass('btn-sm btn-primary');
      // Add event listener for opening and closing details
      $(`#${id} tbody`).on('click', 'td.details-control', (e) => {
        const tr = (<any>$(this)).closest('tr');
        const row = this.dataTableInstance.row( tr );
        const target = $(`#${e.target.id}`);
        if ( row.child.isShown() ) {
          this.handleIconSwitch(target);
          tr.removeClass('shown');
          $('.dtr-details').addClass('table-bordered table-hover table-striped');

        }
        else {
          this.handleIconSwitch(target);
          tr.addClass('shown');
          $('.dtr-details').addClass('table-bordered table-hover table-striped');

        }
      });
    }, 400);

  }
  public handleIconSwitch(target) {
    if(target.hasClass('isShown')) {
      target.removeClass('isShown');
      target.addClass('isNotShown');
    } else {
      target.addClass('isShown');
      target.removeClass('isNotShown');
    }
  }
  public confirmAction(callback, onDismiss?) {
    const swalWithBootstrapButtons = swal.mixin({
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger mr-2',
      buttonsStyling: false,
    });
    swalWithBootstrapButtons({
      title: 'Are you sure?',
      // text: `You won't be able to revert action! `,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        callback();
      } else if (
        // Read more about handling dismissals
        result.dismiss === swal.DismissReason.cancel
        
      ) {
        onDismiss()
      }
    });
  }
  public actionRequireLogout(callback) {
    const swalWithBootstrapButtons = swal.mixin({
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      buttonsStyling: false,
    });
    swalWithBootstrapButtons({
      title: 'Are you sure?',
      text: `This action requires the system to log you out!`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, proceed!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        callback();
      } else if (
        // Read more about handling dismissals
        result.dismiss === swal.DismissReason.cancel
      ) {
      }
    });
  }
}
